import Api from '@api';

import common from './blocks/common'
import tag from './blocks/tag'

import { formConfig } from './config/formConfig'

export default {
  name: 'invHistoryDetail',
  components: {
    common,
    tag
  },
  data() {
    const thead = formConfig(this).thead;
    return {
      commonData: {},
      thead,
      redis: {}
    };
  },
  computed:{
    injectData(){
      return this.$route.query || {}
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    init(){
      this.getData()
    },
    async getData() {
      let { status, data } = await Api.GetCInventoryByPk({
        KEY: this.injectData.KEY,
        SNAP_DATE: this.injectData.SNAP_DATE
      });
      if (Number(status) === 200) {

        let result = JSON.parse(JSON.stringify(data));
        this.$refs.common.$refs.common.formData = result;

        this.thead
          .filter(item => item !== "THead")
          .forEach(item => {
            this.$refs.tag.$refs[item][0].formData = result
          })
      }
    },
    handleConfirm() {
      this.$emit('close')
    },
    handleClose() {
      this.$emit('close')
    }
  }
}